import { useSearch } from "@tanstack/react-router";
import { useContext, useState } from "react";
import useLocales from "src/hooks/useLocales";
import { useRegisterDemoRequest } from "src/services/demo/commands/register";
import SnackbarUtils from "src/utils/SnackbarUtils";

import Context from "../../../context";

export type VerifyForm = {
	email: string;
};

export default function useSendEmail() {
	const [loading, setLoading] = useState(false);

	const { actions, state } = useContext(Context);

	const { translate } = useLocales();
	const { mutate } = useRegisterDemoRequest();
	const { locale }: { locale: string } = useSearch({
		strict: false
	});

	const onSuccess = (email: string) => {
		setLoading(false);
		actions.onSendVerificationEmail(email);
		if (state.email) SnackbarUtils.success(translate("demo.resend_email"));
	};

	const onError = ({ response }: any, onFailure: () => void) => {
		setLoading(false);
		let message = "demo.email_confirmation_error_1";
		if (response.data && response.data.message === "PERSONAL_EMAIL") {
			onFailure();
		} else SnackbarUtils.error(translate(message));
	};

	const onSubmit = ({ email }: VerifyForm, onFailure: () => void) => {
		setLoading(true);
		mutate(
			{ email, language: locale },
			{
				onSuccess: () => onSuccess(email),
				onError: (error) => onError(error, onFailure)
			}
		);
	};

	return {
		onSubmit,
		loading
	};
}
